import { Paper } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect } from "react";
import { useState } from "react";
import useDatatableAddon from "../../Hooks/useDatatableAddon";
import MUIDataTable from "mui-datatables";
import useSave from "../../Hooks/useSave";
import { useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function Labels() {
  const [labels, setLabels] = useState([]);
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();
  const { fetchGraphql, DialogSave } = useSave();

  useEffect(() => {
    fetchGraphql({
      query: `
        query Labels {
          labels {
            label
            name
            productId
          }
        }`,
    }).then((result) => setLabels(result.data.labels));
  }, []);

  const updateLabel = (productId, label) => {
    fetchGraphql({
      query: `
       mutation Mutation($label: LabelInput) {
        updateLabel(Label: $label)
      }`,
      variables: {
        label: {
          productId: productId,
          label: label,
        },
      },
    }).then(() => {
      console.log("label updated");
    });
  };

  const addonOptions = {
    rowsPerPage: 50,
    save: (tableMeta) => updateLabel(tableMeta.rowData[0], tableMeta.rowData[2]),
    edit: () => {},
  };

  const [
    textField,
    selectField,
    newRecord,
    actions,
    options,
    checkboxField,
    multipleSelect,
    dateField,
    bigTextField,
  ] = useDatatableAddon(labels, setLabels, "productId", addonOptions);

  const columns = [
    {
      name: "productId",
      options: {
        display: "excluded",
        
      },
    },
    {
      name: "name",
      label: "Product Name",
    },
    {
      name: "label",
      label: "Label",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            tabNext: true,
            width: "250px",
            type: "string",
          };

          return bigTextField(tableMeta, value, options, updateValue);
        },
      },
    },
    { ...actions },
  ];

  return (
    <>
      <DialogSave />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Paper
        sx={{ margin: "10px", width: "100%", height: "100%", overflow: "auto" }}
      >
        <Box sx={{ margin: "20px 20px" , height: "2000px" }}>
          <MUIDataTable
            sx={{ height: "2000x" }}
            title={"Labels"}
            data={labels}
            columns={columns}
            options={options}
          />
        </Box>
      </Paper>
    </>
  );
}

export default Labels;
